<template>
  <div class="carousel">
    <transition name="slide-right" mode='out-in'>
      <div class="d-flex justify-content-center align-items-center">
        <img class="item" :src="currentPicture">
      </div>
    </transition>
    <a v-if="canGoPrevious" class="previous-button" role="button" @click.prevent="goPrevious">
      <i class="carousel-control-prev-icon fas fa-angle-left" aria-hidden="true"></i>
      <span class="sr-only">Previous</span>
    </a>
    <a v-if="canGoNext" class="next-button" role="button" @click.prevent="goNext">
      <i class="carousel-control-next-icon fas fa-angle-right" aria-hidden="true"></i>
      <span class="sr-only">Next</span>
    </a>
  </div>
</template>

<style scoped lang="scss">
@import "../assets/styles/iouu/mixins";

  .carousel, .carousel > *, .item {
    height: 100%;
    max-height: 800px;

    @include ds {
      max-height: 600px;
    }
  }
  .previous-button, .next-button  {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 15%;
    color: #fff;
    text-align: center;
    opacity: .8;
    font-size: 2rem;
    color: #000;
    
    i {
      background-image: none;
      border: 1px solid #fff;
      border-radius: 50%;
      width: auto;
      height: auto;
      padding: 5px 12px;
      text-shadow: 2px 3px 2px rgba(255, 255, 255, 1);
    }
  }
  .previous-button {
    left: 0;
  }
  .next-button {
    right: 0;
  }

  .carousel img.item {
    width: auto;
    height: 700px;

    @include sm {
       height: auto;
    }

    @include xs {
      height: auto;
    }
  }
/* Não deveria precisar disso, já que o style de transições já está sendo adicionado em todas as paginas */

.slide-left-leave-active, .slide-left-enter-active,
.slide-right-leave-active, .slide-right-enter-active {
  transition: 0.5s;
}
.slide-left-enter {
  transform: translate(50%, 0);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translate(-50%, 0);
  opacity: 0;
}
.slide-right-enter {
  transform: translate(-50%, 0);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translate(50%, 0);
  opacity: 0;
}
</style>

<script>
  export default {
    data() {
      return {
        currentIndex: 0,
        transitionName: 'slide-left',
      }
    },
    props: {
      pictures: {type: Array, required: true}
    },
    computed: {
      currentPicture() { return this.pictures[this.currentIndex] },
      canGoPrevious() { return this.currentIndex > 0 },
      canGoNext() { return this.currentIndex < this.pictures.length - 1 }
    },
    methods: {
      goPrevious() {
        this.transitionName = 'slide-right'
        if(this.canGoPrevious) this.currentIndex -= 1
      },
      goNext() {
        this.transitionName = 'slide-left'
        if(this.canGoNext) this.currentIndex += 1
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Carousel.vue